exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-radio-button {\n  border: 1px solid #e0e3e6;\n  border-radius: 7px;\n  padding: 7px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 15px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n.course-radio-button:hover {\n  background: rgba(85, 110, 230, 0.1254901961);\n}\n.course-radio-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.course-radio-button.active {\n  font-weight: 500;\n  background: #556ee6;\n  border: 1px solid #556ee6;\n  color: #FFF;\n}\n.course-radio-button label {\n  cursor: pointer;\n  margin-bottom: 0px;\n}", ""]);

// exports
